<template>
  <div>
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        Ship Detail Component
        <p class="pl-4">|</p>
      </h1>
      <p class="pr-4"></p>
      <vs-button color="#5b3cc4" type="filled" icon="search" @click="regrid"
        >List</vs-button
      >
      <p class="pr-4"></p>
      <!-- <vs-button color="success" type="filled" icon="add" @click="cusAdd">Add</vs-button>
      <p class="pr-4"></p>-->
      <vs-dropdown>
        <vs-button
          class="btn-drop"
          type="filled"
          icon="local_shipping"
          color="success"
          v-if="btndis"
          >Confirm Ship</vs-button
        >
        <!-- <a href="#">Hola mundo</a> -->

        <vs-dropdown-menu>
          <vs-dropdown-item @click="goItem">By Item</vs-dropdown-item>
          <!-- <vs-dropdown-item @click="goAllocate">By Allocate</vs-dropdown-item> -->
          <!-- <vs-dropdown-item @click="goPallet">By Pallet</vs-dropdown-item> -->
        </vs-dropdown-menu>
      </vs-dropdown>
      <p class="pr-4"></p>
    </div>

    <transition-group
      enter-active-class="animated lightSpeedIn"
      leave-active-class="animated lightSpeedOut"
    >
      <!-- <palldadd v-if="addshow" :key="addshow" :acstate="acstate" :recid="recid" @grid="grid"></palldadd> -->
      <aggrid
        v-if="gridshow"
        :key="gridshow"
        :masrec="masrec"
        @recsel="recsel"
        @mousedown.middle.native="getXY"
      ></aggrid>
      <inberror v-if="errorshow" key="errorshow" :errdata="errdata"></inberror>
    </transition-group>

    <modal
      name="oneModal"
      :width="400"
      :height="300"
      @before-close="beforeModalClose"
    >
      <div class="p-2 hedd">Pallet Number</div>
      <div class="vx-row p-4">
        <div class="vx-col w-4/5 pb-8">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-code"
            icon-no-border
            label-placeholder="Pick Number"
            v-model="pickOrdersNumber"
          />
        </div>

        <div class="vx-col w-4/5">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>Pallet</span>
              </div>
            </template>
            <vs-select autocomplete v-model="onepallet" class="w-full">
              <vs-select-item
                v-for="pallet in pallets"
                :key="pallet.code"
                :value="pallet.code"
                :text="pallet.name"
              />
            </vs-select>
          </vx-input-group>
        </div>
      </div>
      <div class="vx-row pl-4 -pt-2">
        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" @click="onSavePallet">Submit</vs-button>
          <vs-button
            color="warning"
            type="border"
            class="mb-2"
            @click="onResetPallet"
            >Reset</vs-button
          >
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import aggrid from "./grid.vue";
import moment from "moment";

import axios from "axios";
import {
  BASE_API_URL,
  // PROX_URL,
  // NETBAY_URL,
  ENV_CHECK,
} from "@/constants/index.ts";
import inberror from "./inberror";

export default {
  data() {
    return {
      userid: "",
      businessPartnersCode: "",
      companyGroupsCode: "",
      errordata: null,
      errorshow: false,
      pallets: [],
      onepallet: null,
      pickOrdersNumber: null,
      addshow: false,
      gridshow: false,
      btndis: false,
      recid: "0",
      curX: null,
      curY: null,
      acstate: null,
      masrec: null,
      pickdetails: null,
      fabact: [
        // { act: "cusAdd", label: "Add" },
        { act: "onCnSubmit", label: "Confirm Pick" },
        { act: "onPickRemove", label: "Delete Pick" },
        { act: "hideFab", label: "Hide" },
      ],
    };
  },
  computed: {
    fabStyle: function () {
      return {
        left: this.curX + "px",
        top: this.curY + "px",
      };
    },
  },
  methods: {
    handle_function_call(function_name) {
      this[function_name]();
    },
    recsel(val) {
      this.btndis = true;
      this.recid = val;
      this.pickdetails = val;
      // console.log(this.pickdetails);
    },
    // cusAdd() {
    //   this.recid = 0;
    //   this.addshow = true;
    //   this.gridshow = false;
    //   this.btndis = false;
    //   this.acstate = "ADD";
    // },
    grid() {
      this.addshow = false;
      this.gridshow = true;
      this.btndis = false;
      this.$store.dispatch("setReportGrid", 0);
    },
    regrid() {
      // this.$router.replace("/Skus/0");
      this.masrec = "0";
      this.gridshow = false;
      this.errorshow = false;
      setTimeout(() => {
        this.grid();
      }, 1000);
    },
    goPallet() {
      this.$modal.show("oneModal");
    },
    onResetPallet() {
      this.onepallet = "";
    },
    onSavePallet() {
      this.$modal.hide("oneModal");
      // console.log(this.recid);
      const formData = {
        token: localStorage.getItem("token"),
        dbname: localStorage.getItem("dbname"),
        pickOrdersNumber: this.pickOrdersNumber,
        pallets_code: this.onepallet,
      };
      axios
        .post("/ApiCnShipPallet", formData)
        .then((res) => {
          if (res.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Ship Pallet Error",
              text: res.data.message,
              fixed: true,
            });

            this.gridshow = false;
            this.btndis = false;
            this.errorshow = true;
            this.errdata = res.data.errdata;
          } else {
            this.$store.dispatch("setPickDetailsGrid", 1);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Ship Pallet Complete",
              text: res.data.message,
            });
            // this.$socket.client.emit("updatelocations", "LocationsUpdated");
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Ship Error",
            text: err,
          });
        });
    },
    beforeModalClose() {},
    goItem() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Confirm Ship Item? ",
        accept: this.onItemSubmit,
      });
    },
    async onItemSubmit() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.pickdetails,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/picksdetails/cnShipItem`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });

            this.errdata = response.data.errdata;
            this.errorshow = true;
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Ship Complete",
              text: response.data.message,
            });

            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            // if (response.data.mtoconfirmout == "Y") {
            //   if (ENV_CHECK == "PROD") {
            //     this.submitFDMS(response.data.ReferenceNumber);
            //   }

            //   if (response.data.jobType == "BM") {
            //     this.submitFDMSPermit(response.data.ReferenceNumber);
            //   }
            // }

            if (response.data.mtoconfirmout == "Y") {
              if (ENV_CHECK == "PROD") {
                this.submitFDMS(response.data.ReferenceNumber);
              }

              this.submitFDMSPermit(response.data.ReferenceNumber);
            }
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
    async submitFDMSPermit(ReferenceNumber) {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        const formData2 = {
          ReferenceNumber: ReferenceNumber,
          editor: String(this.userid),
        };

        const response2 = await axios.post(
          `${BASE_API_URL}/outbound-svc/cpermits/inboundPermitToFDMSNew`,
          formData2,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (response2.data.status != "success") {
          this.loading = false;
          // this.$vs.notify({
          //   position: "top-right",
          //   color: "danger",
          //   title: "Error from Submit to FDMS",
          //   text: response2.data.message,
          // });
        } else {
          // this.$vs.notify({
          //   position: "top-right",
          //   color: "success",
          //   title: "Submit to FDMS",
          //   text: response2.data.message,
          // });
        }
      } catch (error) {
        alert("กรุณาเข้าระบบอีกครั้ง");
      }
    },
    // async submitFDMSPermit(ReferenceNumber) {
    //   try {
    //     const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    //     const formData2 = {
    //       ReferenceNumber: ReferenceNumber,
    //     };

    //     const response2 = await axios.post(
    //       `${BASE_API_URL}/outbound-svc/cpermits/inboundPermitToFDMS`,
    //       formData2,
    //       {
    //         headers: { Authorization: "Bearer " + token.accessToken },
    //       }
    //     );

    //     if (response2.data.status != "success") {
    //       this.loading = false;
    //       this.$vs.notify({
    //         position: "top-right",
    //         color: "danger",
    //         title: "Error from Submit to FDMS",
    //         text: response2.data.message,
    //         fixed: true,
    //       });
    //     } else {
    //       const NETBAY_TOKEN = localStorage.getItem("NETBAY_TOKEN");
    //       //  console.log(NETBAY_TOKEN);
    //       try {
    //         // console.log('netlogin');
    //         const formData3 = {
    //           declarationNo: response2.data.message[0].dclnumber,
    //           inboundRequestNumber: [response2.data.message[0].number],
    //         };

    //         const response3 = await axios.post(
    //           PROX_URL + NETBAY_URL + `fz-webservice/api/inbound-permit`,
    //           // `https://kongapi.aotga.com/proxy-svc/https://uataotdc.netbay.co.th/fz-webservice/api/zone3-otherport`,
    //           // `https://uataotdc.netbay.co.th/fz-webservice/api/zone3-otherport`,
    //           // `/api/fz-webservice/api/zone3-otherport`,
    //           formData3,

    //           {
    //             headers: {
    //               "Content-Type": "application/json",
    //               token: NETBAY_TOKEN,
    //             },
    //           }
    //         );

    //         if (response3.status == "fail") {
    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "danger",
    //             title: "Error",
    //             text: response3.message,
    //           });
    //         } else {
    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "success",
    //             title: "Submit Success",
    //             text: response3.data.message,
    //           });

    //           const moment = require("moment-timezone");
    //           const timezone = "Asia/Bangkok";
    //           const now = moment().tz(timezone);

    //           const formData = {
    //             number: ReferenceNumber,
    //             code: response3.data.code,
    //             message: response3.data.message,
    //             createdAt: now,
    //           };

    //           await axios.post(
    //             `${BASE_API_URL}/outbound-svc/exborders/resFDMSOut`,
    //             formData,
    //             {
    //               headers: { Authorization: "Bearer " + token.accessToken },
    //             }
    //           );
    //         }
    //       } catch (error) {
    //         // alert("กรุณาเข้าระบบอีกครั้ง");
    //         if (error.response) {
    //           // console.log(error.response.data);
    //           // console.log(error.response.data.message);
    //           // console.log(error.response.status);
    //           // console.log(error.response.headers);
    //           if (error.response.data.message == "Token has expired.") {
    //             this.$vs.notify({
    //               position: "top-right",
    //               color: "danger",
    //               title: "Error",
    //               text: error.response.data.message,
    //             });
    //           } else {
    //             this.$vs.notify({
    //               position: "top-right",
    //               color: "danger",
    //               title: "Error",
    //               text: error.response.data.message,
    //             });

    //             const moment = require("moment-timezone");
    //             const timezone = "Asia/Bangkok";
    //             const now = moment().tz(timezone);

    //             const formData = {
    //               number: ReferenceNumber,
    //               code: error.response.data.code,
    //               message: error.response.data.message,
    //               createdAt: now,
    //             };

    //             await axios.post(
    //               `${BASE_API_URL}/outbound-svc/exborders/resFDMSOut`,
    //               formData,
    //               {
    //                 headers: { Authorization: "Bearer " + token.accessToken },
    //               }
    //             );
    //           }
    //         }
    //       }
    //     }
    //   } catch (error) {
    //     alert("กรุณาเข้าระบบอีกครั้ง");
    //   }
    // },
    async submitFDMS(ReferenceNumber) {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
      // const NETBAY_TOKEN = localStorage.getItem("NETBAY_TOKEN");
      //  console.log(NETBAY_TOKEN);
      try {
        // console.log('netlogin');
        let confirmOutDate = moment().format("YYYYMMDD");
        let confirmOutTime = moment().format("HHmmssss");

        const formData = {
          transactionNo: ReferenceNumber,
          confirmOutDate: confirmOutDate,
          confirmOutTime: confirmOutTime,
          editor: String(this.userid),
        };

        const response = await axios.post(
          `${BASE_API_URL}/outbound-svc/exbdetails/zone3ConfirmOut`,
          formData,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (response.data.status != "success") {
          this.loading = false;
          // this.$vs.notify({
          //   position: "top-right",
          //   color: "danger",
          //   title: "Error from Backend",
          //   text: "Confirm OUT FDMS Failed",
          // });

        } else {
          // this.$vs.notify({
          //   position: "top-right",
          //   color: "success",
          //   title: "Confirm OUT FDMS",
          //   text: "Confirm OUT FDMS Complete",
          // });
        }
      } catch (error) {
        alert("กรุณาเข้าระบบอีกครั้ง");
      }
    },
    // async submitFDMS(ReferenceNumber) {
    //   const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
    //   const NETBAY_TOKEN = localStorage.getItem("NETBAY_TOKEN");
    //   //  console.log(NETBAY_TOKEN);
    //   try {
    //     // console.log('netlogin');
    //     let confirmOutDate = moment().format("YYYYMMDD");
    //     let confirmOutTime = moment().format("HHmmssss");

    //     const formData3 = {
    //       transactionNo: ReferenceNumber,
    //       confirmOutDate: confirmOutDate,
    //       confirmOutTime: confirmOutTime,
    //     };

    //     const response3 = await axios.post(
    //       PROX_URL + NETBAY_URL + `fz-webservice/api/zone3-confirm-out`,
    //       // `https://kongapi.aotga.com/proxy-svc/https://uataotdc.netbay.co.th/fz-webservice/api/zone3-otherport`,
    //       // `https://uataotdc.netbay.co.th/fz-webservice/api/zone3-otherport`,
    //       // `/api/fz-webservice/api/zone3-otherport`,
    //       formData3,

    //       {
    //         headers: {
    //           "Content-Type": "application/json",
    //           token: NETBAY_TOKEN,
    //         },
    //       }
    //     );

    //     if (response3.status == "fail") {
    //       this.$vs.notify({
    //         position: "top-right",
    //         color: "danger",
    //         title: "Error",
    //         text: response3.message,
    //       });
    //     } else {
    //       this.$vs.notify({
    //         position: "top-right",
    //         color: "success",
    //         title: "Submit Success",
    //         text: response3.data.message,
    //       });

    //       const moment = require("moment-timezone");
    //       const timezone = "Asia/Bangkok";
    //       const now = moment().tz(timezone);

    //       const formData = {
    //         number: ReferenceNumber,
    //         code: response3.data.code,
    //         message: response3.data.message,
    //         createdAt: now,
    //       };

    //       await axios.post(
    //         `${BASE_API_URL}/outbound-svc/exborders/resFDMSMtoOut`,
    //         formData,
    //         {
    //           headers: { Authorization: "Bearer " + token.accessToken },
    //         }
    //       );
    //     }
    //   } catch (error) {
    //     // alert("กรุณาเข้าระบบอีกครั้ง");
    //     if (error.response) {
    //       // console.log(error.response.data);
    //       // console.log(error.response.data.message);
    //       // console.log(error.response.status);
    //       // console.log(error.response.headers);
    //       if (error.response.data.message == "Token has expired.") {
    //         this.$vs.notify({
    //           position: "top-right",
    //           color: "danger",
    //           title: "Error",
    //           text: error.response.data.message,
    //         });
    //       } else {
    //         this.$vs.notify({
    //           position: "top-right",
    //           color: "danger",
    //           title: "Error",
    //           text: error.response.data.message,
    //         });

    //         const moment = require("moment-timezone");
    //         const timezone = "Asia/Bangkok";
    //         const now = moment().tz(timezone);

    //         const formData = {
    //           number: ReferenceNumber,
    //           code: error.response.data.code,
    //           message: error.response.data.message,
    //           createdAt: now,
    //         };

    //         await axios.post(
    //           `${BASE_API_URL}/outbound-svc/exborders/resFDMSMtoOut`,
    //           formData,
    //           {
    //             headers: { Authorization: "Bearer " + token.accessToken },
    //           }
    //         );
    //       }
    //     }
    //   }
    // },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    hideFab() {
      this.btndis = false;
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(responseponse.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  components: {
    aggrid,
    inberror,
  },
  created() {
    this.checkProfiles();
    // console.log(this.inborders_number);
    this.masrec = this.pickOrdersNumber;
    // console.log(this.masrec);
    if (this.masrec != 0) {
      this.grid();
    }
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}
.fab {
  background-color: rgb(231, 55, 55);
}
.hedd {
  font-weight: bold;
}
</style>
